@let sectionHeading = heading();
@let id = sectionId();
<section [attr.id]="id || null">
  <div class="groove-content-section-prose groove-flow">
    @if (sectionHeading) {
      <h2>{{ sectionHeading }}</h2>
    }
    <ng-content />
  </div>
</section>
